import "react-day-picker/lib/style.css";
/**
 * Temporary hack due to css styling being lost on client side routing
 * so we import it globally here. May be needed for other compoenents suffering missing css issues.
 * This is either a nextjs or webpack bug?!?
 */
import "react-phone-number-input/style.css";
import "react-select/dist/index-ea9e225d.cjs.prod";
import "react-select/dist/react-select.cjs.prod";
import "react-select/dist/Select-fd7cb895.cjs.prod";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { AppStateProvider } from "../contexts/appState";
import { AuthProvider } from "../contexts/auth";

const Noop = ({ children }) => children;

function MyApp({ Component, pageProps }) {
  const Layout = Component.Layout || Noop;
  const Tile = Component.Tile;
  const Header = Component.Header ?? true;
  const Grid = Component.Grid ?? true;
  const Footer = Component.Footer ?? true;
  const Title = Component.Title ?? "Valmeego";

  return (
    <AppStateProvider>
      <AuthProvider>
        <Layout
          tile={Tile}
          grid={Grid}
          header={Header}
          footer={Footer}
          title={Title}
        >
          <Component {...pageProps} />
        </Layout>
      </AuthProvider>
    </AppStateProvider>
  );
}

export default MyApp;
